export const currencyFormat = (amount) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0, // IDR typically does not use decimals
    maximumFractionDigits: 0,
  }).format(amount);
};